module.exports = "/dist/roboto-latin-700italic.svg?bf39ef96a254805657605c016263db25";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-700italic.svg
// module id = 93
// module chunks = 0